import { render, staticRenderFns } from "./status-form-success.vue?vue&type=template&id=554d2636&scoped=true&"
import script from "./status-form-success.vue?vue&type=script&lang=js&"
export * from "./status-form-success.vue?vue&type=script&lang=js&"
import style0 from "./status-form-success.vue?vue&type=style&index=0&id=554d2636&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d2636",
  null
  
)

export default component.exports